var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "flex-column" },
    [
      _c("header", [
        _c("h1", { staticClass: "m-0 fs-32 regular mb-6" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Choisissez votre plan Sellsy")) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "plans-card flex-row mt-6 pb-6 font-patron" },
        _vm._l(_vm.plansData, function(card, cardKey) {
          return _c(
            "div",
            {
              key: cardKey,
              staticClass:
                "plans-card-data flex-column secondary-blue fs-4 ai-center",
              class: [card.code === _vm.currentPlan ? "isPlanActual" : ""]
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "plans-card-data-content acenter flex-column white-bkg p-4 pt-5 pb-5"
                },
                [
                  card.code === _vm.currentPlan
                    ? [
                        _c(
                          "p",
                          {
                            staticClass:
                              "m-0 primary plan-card-data-content-actual bold fs-2"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("upperCase")(
                                    _vm.$l10n.__("plan actuel")
                                  )
                                ) +
                                "\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("Underline", { staticClass: "underline-svg mb-1" })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h1", { staticClass: "semibold mt-0 mb-5" }, [
                    _vm._v(_vm._s(card.title))
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "btn secondary-grey-bkg btn-small black" },
                    [_vm._v(_vm._s(_vm.$l10n.__("À partir de")))]
                  ),
                  _vm._v(" "),
                  _c("h2", { staticClass: "mt-1 mb-0 bold" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("numberformatWithOptions")(
                            _vm._f("floatNumber")(
                              _vm.getPriceAmountByMonth(card.code)
                            ),
                            { precision: 0 },
                            true
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("small", { staticClass: "fs-3 bold" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$l10n.__("/utilisateur")) +
                          "\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {},
                    _vm._l(card.limits, function(limit, limitKey) {
                      return _c(
                        "li",
                        {
                          key: limitKey,
                          staticClass: "fs-3 flex-row mt-4 pb-4"
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.limitLabel[limitKey].value))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(_vm._s(limit.value))
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  !_vm.canBeSelected(card)
                    ? _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.contact_sales"),
                          type: "primary-contrast",
                          size: "large",
                          onclick: "MySupport.getForm()"
                        }
                      })
                    : _c("CompassButton", {
                        attrs: {
                          label: _vm.getButtonLabel(card.code),
                          type: "primary",
                          size: "large"
                        },
                        on: {
                          click: function($event) {
                            return _vm.submitSelectedPlan(card.code)
                          }
                        }
                      })
                ],
                2
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("questions")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }